<template lang="pug">
  .notes-partial
    .form-row 
      Title(:title="$t(`${prefix}.title`)")
    .form-row_last
      FormPartial(
        :prefix="prefix"
        :item="item"
        :fields="fields"
      )
</template>

<script>
  export default {
    components: {
      Title: () => import("@/components/CompanySystem/Title"),
      FormPartial: () => import("@/components/CompanySystem/Reservation/FormPartial")
    },

    props: {
      prefix: {
        type: String,
        required: true
      },
      item: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      fields() {
        return ["number_of_passengers", "scheduled_flight"]
      }
    }
  }
</script>
